import React from "react";
import { useJsApiLoader } from "@react-google-maps/api";
import ErrorBanner from "components/molecules/InfoBanners/ErrorBanner";

import { GOOGLE_LIBRARIES } from "constants/important";
/**
 * This throws console warning that can't be surpressed and it is OK.
 */
export default function withLoadedMap<T>(Component: React.FC<T>): React.FC<T> {
  return function WrappedComponent(props: T) {
    const { isLoaded, loadError } = useJsApiLoader({
      googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY || "",
      libraries: GOOGLE_LIBRARIES,
    });

    if (loadError) {
      return <ErrorBanner />;
    }

    return isLoaded ? <Component {...props} /> : <></>;
  };
}
